var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoKeyinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.81 26.81"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.21 20.58a1.94 1.94 0 01-1.37.57h-1v.64a1.93 1.93 0 01-1.93 1.94h-.67v.64a1.93 1.93 0 01-1.93 1.94H3.08A2.59 2.59 0 01.5 23.73v-3.34a2.57 2.57 0 01.76-1.82l7.18-7.18A9.07 9.07 0 0115.5.68 8.88 8.88 0 0117.28.5a9 9 0 010 18.07 8.9 8.9 0 01-1.86-.2l-2.2 2.21zm1.45-5.1l.74.23a6.45 6.45 0 10-4.31-8 6.58 6.58 0 000 3.73l.24.75-8.25 8.18v3.36h2.58v-.65a1.93 1.93 0 011.94-1.93h.64v-.65a1.93 1.93 0 011.94-1.93h1.4zm6.49-6a1.29 1.29 0 01-2.58 0 1.29 1.29 0 00-1.29-1.29 1.29 1.29 0 010-2.58 3.87 3.87 0 013.87 3.92z",
    fill: "#fdc800",
    stroke: "#fafafa",
    strokeMiterlimit: 10,
    "data-name": "Capa 1"
  }))));
}

export default SvgCoKeyinline;